// extracted by mini-css-extract-plugin
export default {"preloader":"App_preloader__85o3B"};